import { Alert, Button, Table } from "antd";
import CustomDrawer from "components/CustomDrawer";
import { BUDGET_TIER_LABEL } from "features/ConsultRequest/core/constants";
import { formatDateTime, formatNumber } from "features/ConsultRequest/core/utils";
import { mapSnapshotPrice } from "features/ConsultRequest/data/mappers";

const Row = ({ label, children }) => (
  <div style={{ display: "flex", padding: "4px 0" }}>
    <span style={{ width: 140, color: "#5b667f" }}>{label}</span>
    <span style={{ flex: 1 }}>{children}</span>
  </div>
);

export default function PackageSnapshotDrawer({ visible, snapshot, onClose }) {
  const s = snapshot || {};
  const columns = [
    {
      title: "SẢN PHẨM",
      render: (_, p) => (
        <div>
          <div>{p.productName}</div>
          {p.model && <div style={{ color: "#8c8c8c" }}>{p.model}</div>}
        </div>
      ),
    },
    { title: "NHÃN HIỂN THỊ", render: (_, p) => p.displayLabel || "—" },
    { title: "SL", dataIndex: "quantity", width: 60 },
    { title: "ĐƠN GIÁ", render: (_, p) => formatNumber(p.unitPrice) },
    { title: "THÀNH TIỀN", render: (_, p) => formatNumber(p.lineTotal) },
  ];
  return (
    <CustomDrawer
      visible={visible}
      onClose={onClose}
      width={720}
      title="Gói đề xuất khách đã xem"
      buttonOk={<span />}
      labelCancel="Đóng"
      propsDrawer={{ closable: true, maskClosable: true }}
      content={
        <div>
          <Alert
            type="info"
            message={`Bản chụp tại lúc khách gửi phiếu · ${formatDateTime(s.snapshotAt)}`}
            style={{ marginBottom: 12 }}
          />
          <Row label="Loại dự án">{s.projectTypeName}</Row>
          <Row label="Mức ngân sách">{BUDGET_TIER_LABEL[s.budgetTier]}</Row>
          <Row label="Tên gói">{s.name}</Row>
          <Row label="Tiêu đề gói">{s.title}</Row>
          <Row label="Mô tả ngắn">
            {(s.shortDescriptionLines || []).map((line) => (
              <div key={line}>{`✓ ${line}`}</div>
            ))}
          </Row>
          <Row label="Khoảng giá">{mapSnapshotPrice(s)}</Row>
          {s.priceNote && <Row label="Ghi chú">{s.priceNote}</Row>}
          <Table
            style={{ marginTop: 12 }}
            rowKey="productId"
            columns={columns}
            dataSource={s.products || []}
            pagination={false}
            footer={() => <b>{`Tổng giá trị sản phẩm (nội bộ): ${formatNumber(s.totalProductValue)}`}</b>}
          />
          <Button style={{ marginTop: 16 }} onClick={onClose}>
            Đóng
          </Button>
        </div>
      }
    />
  );
}
